import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import createModel, {
  Any,
  DeepPartial,
  Mapped,
  Silent,
} from "@/__main__/data-model.mjs";
import { model as appSettings } from "@/data-models/app-settings.mjs";

export const model = {
  id: Silent(String),
  accountUserId: String,
  config: {
    blitzApp: DeepPartial(appSettings),

    ...Mapped({
      key: String,
      value: Any,
    }),
  },
} satisfies ModelDefinition;

export type UserPreferences = FromModel<typeof model>;

const UserPreferencesModel = createModel({
  data: model,
}).transform(model, (data) => data.data);

export default UserPreferencesModel;
